export default __webpack_public_path__ + "static/media/tasks_in_progress.01b58da5.svg";